import { render, staticRenderFns } from "./PinAnswerCard.vue?vue&type=template&id=219ccad1&scoped=true"
import script from "./PinAnswerCard.vue?vue&type=script&lang=js"
export * from "./PinAnswerCard.vue?vue&type=script&lang=js"
import style0 from "./PinAnswerCard.vue?vue&type=style&index=0&id=219ccad1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ccad1",
  null
  
)

export default component.exports